// app/javascript/packs/your_pack.js
import { I18n } from "i18n-js";
// Import separate locale files exported by i18n-js
import en from "../i18n/en.json";
import fr from "../i18n/fr.json";

// Create a new I18n instance and register locales
const i18n = new I18n({
  en: en.en, 
  fr: fr.fr,
});

// Use the Ruby YML-exported translations (via i18n-js rake export)
i18n.defaultLocale = "en";
i18n.enableFallback = true;

const meta = document.querySelector('meta[name="locale"]');
i18n.locale = (meta && meta.content) || "en";

window.I18n = i18n;
